function isObject(value) {
  return value != null && typeof value === "object" && !Array.isArray(value);
}
export {
  isObject
};
//# sourceMappingURL=isObject.mjs.map